export default __webpack_public_path__ + "static/best_buy-1372463b8dc8b1748328deb31eb81485.png";